import React from 'react';
import Home from './HomePage/';
import Products from './ProductsPage/';
import SingleProduct from './SingleProductPage/';
import PrivateRoute from './PrivateRoute/';

// Route-level code splitting: Home/Products/SingleProduct stay eager since
// they're the main ad/organic landing pages (an extra network round-trip
// there costs conversions). Everything else — checkout, auth, account,
// static info pages — is loaded on demand.
const About = React.lazy(() => import('./AboutPage/'));
const Cart = React.lazy(() => import('./CartPage/'));
const Checkout = React.lazy(() => import('./CheckoutPage/'));
const Login = React.lazy(() => import('./LoginPage/'));
const Register = React.lazy(() => import('./RegisterPage/'));
const Forgot = React.lazy(() => import('./ForgotPasswordPage/'));
const Reset = React.lazy(() => import('./ResetPasswordPage/'));
const Error = React.lazy(() => import('./ErrorPage/'));
const OrdersPage = React.lazy(() => import('./OrdersPage/'));
const ProfilePage = React.lazy(() => import('./ProfilePage/'));
const FAQPage = React.lazy(() => import('./FAQPage/'));
const ShippingPage = React.lazy(() => import('./ShippingPage/'));
const ReturnsPage = React.lazy(() => import('./ReturnsPage/'));
const TrackOrderPage = React.lazy(() => import('./TrackOrderPage/'));
const OurStoryPage = React.lazy(() => import('./OurStoryPage/'));
const ContactPage = React.lazy(() => import('./ContactPage/'));
const OffersPage = React.lazy(() => import('./OffersPage/'));
const WishlistPage = React.lazy(() => import('./WishlistPage/'));

export {
  Home,
  About,
  Products,
  Cart,
  SingleProduct,
  Checkout,
  Login,
  Register,
  Forgot,
  Reset,
  Error,
  OrdersPage,
  PrivateRoute,
  ProfilePage,
  FAQPage,
  ShippingPage,
  ReturnsPage,
  TrackOrderPage,
  OurStoryPage,
  ContactPage,
  OffersPage,
  WishlistPage,
};
